<template>
    <div>
        <div class="loader mt-5" v-if="loading"></div>
        <div v-show="!loading && register">
            <!--{{eventClaims}}-->
            <page-title
                :title="formTitle"
                :showDescription="true"
                :description="eventName"
            ></page-title>
            <br/>
            <div v-if="isEvent" v-cloak>
                <tabs :options="{ useUrlFragment: false, loadSavedTab: false }" cache-lifetime="10"
                    class="m-1"
                    @changed="tabChanged">
                    <tab id="generalTab" :name="$t('registers.events.generalData.title')">
                        <div>
                            <div class="btn-group" v-if="canWriteEvents && !showSaveOnGeneralData && canUnlockForEdit">
                                <button type="button" class="btn btn-primary btn"
                                        @click="unLockForEditButtonClicked">
                                    <i class="fa fa-unlock-alt"></i>
                                    {{ $t("buttons.unlockForEdit") }}
                                </button>
                            </div>
                            <div class="btn-group" v-if="canWriteEvents && showSaveOnGeneralData">
                                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                                    <i class="fas fa-save"></i>
                                    {{ $t("buttons.save.btnText") }}
                                </button>
                                <button v-if="!isNew" type="button" class="btn btn-primary btn" @click="onCopy">
                                    <i class="fas fa-copy"></i>
                                    {{ $t("buttons.copy.btnText") }}
                                </button>
                            </div>
                            <div class="card" v-if="isEvent" v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h5 m-0">
                                        {{ $t("registers.events.generalData.title") }}
                                    </div>
                                </div>
                                <div class="card-body" v-if="register">
                                    <event-general-data :model="register.registerEntityExtension"
                                                        :registerId="registerId"
                                                        :entryId="entryId"
                                                        :isEvent="isEvent"
                                                        :registerName="registerName"></event-general-data>
                                </div>
                            </div>

                            <div v-if="register">
                                <panel v-for="(panel, index) in register.panels"
                                       :panel="panel"
                                       :key="'generalTabPanel' + index"
                                       :isNew="isNew"
                                       @deleteSavedFile="deleteSavedFile"></panel>
                            </div>
                            <div class="text-center mt-5" v-if="canWriteEvents && showSaveOnGeneralData">
                                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                                    <i class="fas fa-save"></i>
                                    {{ $t("buttons.save.btnText") }}
                                </button>
                            </div>
                        </div>
                    </tab>

                    <tab id="relatedFormTab" v-if="canReadFormsManagеment && !isNew"
                         :name="$t('registers.forms.management')">
                        <div v-if="canReadFormsManagеment">
                            <div v-if="isNew">
                                <h4 class="text-warning text-center">{{ $t("registers.events.notSaved") }}</h4>
                            </div>
                            <div v-else-if="!isNew && relatedFormTabActive">
                                <page-title :title="formTitle + ' / ' + $t('registers.forms.management')"
                                            :showTitle="false"></page-title>

                                <forms-management :eventId="Number(entryId)"
                                                  :details="false"
                                                  :can-write="canWriteForms"
                                                  :is-locked-for-edit="!showSaveOnGeneralData"
                                                  :showRelatedForms="showRelatedForms"
                                                  :showHeader="false">
                                </forms-management>
                            </div>
                        </div>
                    </tab>

                    <tab id="rankingTab" v-if="canReadRankingCriteria && !isNew"
                         :name="$t('registers.events.evaluation.criteria.title')">
                        <div v-if="canReadRankingCriteria">
                            <div v-if="isNew">
                                <h4 class="text-warning text-center">{{ $t("registers.events.notSaved") }}</h4>
                            </div>
                            <div v-else-if="!isNew && rankingTabActive && isEvent" v-cloak>
                                <page-title :title="formTitle + ' / ' + $t('registers.events.evaluation.criteria.title')"
                                            :showTitle="false"></page-title>

                                <div v-if="showNewRankingCriteriaLogic">
                                    <RankingCriteriaNew :is-locked-for-edit="!showSaveOnGeneralData" :eventFormIds="eventFormIds">

                                    </RankingCriteriaNew>
                                </div>
                                <div v-else>
                                    <hr />
                                    <hr />
                                    <h5>
                                        Стар вариант на добавяне на критерии за оценка. Следва да се премахне, когато
                                        всички е готово
                                    </h5>
                                    <ranking-criteria :eventId="Number(entryId)"
                                                      :is-locked-for-edit="!showSaveOnGeneralData">
                                    </ranking-criteria>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="participationRequestsTab"
                         v-if="hasReadRights && !isNew && canReadTempRanking"
                         :name=" $t('registers.events.evaluation.participationRequests.title')">
                        <div v-if="hasReadRights && !isNew && canReadTempRanking">
                            <div v-if="participationRequestsTabActive && isEvent" v-cloak>
                                <page-title :title="formTitle + ' / ' + $t('registers.events.evaluation.participationRequests.title')"
                                            :showTitle="false"></page-title>

                                <ParticipationRequestsGrid :eventId="Number(entryId)"
                                                           :is-locked-for-edit="!showSaveOnGeneralData">
                                </ParticipationRequestsGrid>
                            </div>
                        </div>
                    </tab>

                    <tab id="accommodationRequestsTab"
                         v-if="hasReadRights && !isNew && canReadTempRanking"
                         :name="$t('registers.events.evaluation.accommodationRequests.title')">
                        <div v-if="hasReadRights && !isNew && canReadTempRanking">
                            <div v-if="accommodationRequestsTabActive && isEvent" v-cloak>
                                <page-title :title="formTitle + ' / ' + $t('registers.events.evaluation.accommodationRequests.title')"
                                            :showTitle="false"></page-title>

                                <AccommodationRequestsGrid :eventId="Number(entryId)"
                                                           :is-locked-for-edit="!showSaveOnGeneralData">
                                </AccommodationRequestsGrid>

                                <h3 class="mt-4">{{ $t('confirmationRejection.title') }}</h3>

                                <ConfirmationRejectionsGrid :eventId="Number(entryId)"
                                                            :is-locked-for-edit="!showSaveOnGeneralData">
                                </ConfirmationRejectionsGrid>
                            </div>
                        </div>
                    </tab>

                    <tab id="tempRankingTab" v-if="hasReadRights && !isNew && canReadTempRanking"
                         :name="$t('registers.events.evaluation.tempRanking.title')">
                        <div v-if="hasReadRights && !isNew && canReadTempRanking">
                            <div class="card m-1" v-if="tempRankingTabActive && isEvent" v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">
                                        {{$t("registers.events.evaluation.tempRanking.title") }}
                                    </div>
                                </div>
                                <div class="card-body">
                                    <temp-ranking-management ref="tempRankingCriteria"
                                                             :eventId="Number(entryId)"
                                                             :can-write="canWriteTempRanking"
                                                             :is-locked-for-edit="!showSaveOnGeneralData"
                                                             @tempRankingApplied="tempRankingApplied"></temp-ranking-management>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="uninformedParticipantsTab" v-if="hasReadRights
                                                           && !isNew
                                                           && canReadUninformedPerticipants"
                         :name="$t('sentEmails.gridHeaders.UninformedParticipants')">
                        <div v-if="uninformedTabActive">
                            <UninformedPartipants ref="uninformedParticipants"
                                                  :entryId="Number(entryId)"
                                                  :can-write="canWriteUninformedPerticipants"
                                                  :is-locked-for-edit="!showSaveOnGeneralData">
                            </UninformedPartipants>
                        </div>
                    </tab>

                    <tab id="participantsTab" v-if="hasReadRights && !isNew && canReadParticipants"
                         :name="$t('registers.events.participants.title')">
                        <div v-if="participantsTabActive &&
                                   hasReadRights &&
                                   canReadParticipants" v-cloak>
                            <participants-management ref="participantsManagement"
                                                     :registerId="registerId"
                                                     :entryId="entryId"
                                                     :can-write="canWriteParticipants"
                                                     :is-locked-for-edit="!showSaveOnGeneralData"
                                                     @participantsImported="participantsImported"
                                                     @onEdit="participantsImported"></participants-management>

                            <EventCertificateDefaultReport
                                :model="register.registerEntityExtension"
                                :allowEdit="true" />

                            <ParticipantsMoodleActivityCertificatesGrid :entry-id="entryId"></ParticipantsMoodleActivityCertificatesGrid>

                        </div>
                    </tab>

                    <tab id="lecturersTab" v-if="hasReadRights && canReadLectors && !isNew"
                         :name="$t('registers.lecturers.title')">
                        <div v-if="isEvent && hasReadRights && canReadLectors" v-cloak>
                            <div v-if="lecturersTabActive && isEvent">
                                <lecturers-management ref="lecturersManagement"
                                                      :registerId="registerId"
                                                      :entryId="entryId"
                                                      :is-locked-for-edit="!showSaveOnGeneralData"
                                                      @participantsImported="participantsImported"
                                                      @onEdit="participantsImported"
                                />

                                <EventLecturerCertificateDefaultReport
                                    :model="register.registerEntityExtension"
                                    :allowEdit="true"
                                />
                            </div>
                        </div>
                    </tab>

                    <tab id="budgetTab" v-if="hasReadRights && !isNew && canReadBudget"
                         :name="$t('registers.events.budget.title')">
                        <div>
                            <div class="card mt-5"
                                 v-if="budgetTabActive &&
                                       hasReadRights &&
                                       isEvent &&
                                       canReadBudget"
                                 v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">
                                        {{ $t("registers.events.budget.title") }}
                                    </div>
                                </div>
                                <div class="card-body">
                                    <budget-planning :register-entity-id="entryId"
                                                     :can-write="canWriteBudget"
                                                     :event-date-from="eventDateFrom"
                                                     :is-locked-for-edit="!showSaveOnGeneralData"
                                                     :event-date-to="eventDateTo"
                                                     show-sync-button/>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="expensesTab" v-if="hasReadRights && !isNew && canReadExpenses"
                         :name="$t('registers.events.costs.title')">
                        <div>
                            <div class="card"
                                 v-if="expensesTabActive &&
                                       hasReadRights &&
                                       isEvent &&
                                       canReadExpenses"
                                 v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">{{ $t("registers.events.costs.title") }}</div>
                                </div>
                                <div class="card-body">
                                    <expenses :register-entity-id="entryId"
                                              :can-write="canWriteExpenses"
                                              :is-locked-for-edit="!showSaveOnGeneralData"
                                              :event-date-from="eventDateFrom"
                                              :event-date-to="eventDateTo"></expenses>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="budgetReportTab" v-if="hasReadRights && !isNew && canReadBudgetReport"
                         :name="$t('registers.events.budgetReport.title')">
                        <div>
                            <div class="card mt-5"
                                 v-if="budgetReportTabActive &&
                                       hasReadRights &&
                                       isEvent &&
                                       canReadBudgetReport"
                                 v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">
                                        {{ $t("registers.events.budgetReport.title" ) }}
                                    </div>
                                </div>
                                <div class="card-body">
                                    <budget-report :register-entity-id="entryId"
                                                   :can-write="canWriteBudgetRreport"
                                                   :event-date-from="eventDateFrom"
                                                   :is-locked-for-edit="!showSaveOnGeneralData"
                                                   :event-date-to="eventDateTo"></budget-report>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="importTab" v-if="hasEditRights && !isNew && canReadParticipants"
                         :name="$t('administration.import.title')">
                        <div>
                            <div class="card mt-5"
                                 v-if="importTabActive &&
                                       hasEditRights &&
                                       isEvent &&
                                       canReadParticipants"
                                 v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">{{ $t("administration.import.title") }}</div>
                                </div>
                                <div class="card-body">
                                    <participants-import :registerId="registerId"
                                                         :entryId="entryId"
                                                         :can-write="canWriteParticipants"
                                                         :is-locked-for-edit="!showSaveOnGeneralData"
                                                         @imported="participantsImported"></participants-import>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="hallEventTab" v-if="hasEditRights && !isNew && canReadAgenda"
                         :name="$t('scheduler.agenda')">
                        <div>
                            <div class="card mt-5"
                                 v-if="hallEventTabActive &&
                                       hasEditRights &&
                                       isEvent &&
                                       canReadAgenda"
                                 v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">{{ $t("scheduler.agenda") }}</div>
                                </div>
                                <div class="card-body">
                                    <hall-event-management :eventId="Number(entryId)"
                                                           :is-locked-for-edit="!showSaveOnGeneralData"
                                                           :details="false"></hall-event-management>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="organizationalCalendarTab" v-if="hasEditRights && !isNew && canReadOrganizationalCalendar"
                         :name="$t('organizationalCalendar.title')">
                        <div>
                            <div class="card mt-5"
                                 v-if="organizationalCalendarTaActive && hasEditRights && isEvent && canReadOrganizationalCalendar"
                                 v-cloak>
                                <div class="card-header bg-primary text-white">
                                    <div class="card-title h4 m-0">{{ $t("organizationalCalendar.title") }}</div>
                                </div>
                                <div class="card-body">
                                    <organizational-calendar-management :eventId="Number(entryId)"
                                                                        :is-locked-for-edit="!showSaveOnGeneralData"
                                                                        :details="false"></organizational-calendar-management>
                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="documentsTab" v-if="hasReadRights && !isNew"
                         :name="$t('registers.events.organizationalDocs')">
                        <div v-if="docsTabActive">
                            <event-docs ref="eventDocs" :eventId="Number(entryId)"></event-docs>
                        </div>
                    </tab>

                    <tab id="subscriptionsTab" v-if="hasReadRights && !isNew && canReadSubscriptions"
                         :name="$t('registers.events.subscriptions.title')">
                        <div v-if="subscriptionsTabActive &&
                                   hasReadRights &&
                                   canReadSubscriptions">
                            <event-subscriptions-grid ref="eventSubscriptionsGrid"
                                                      :showHideButton="false"
                                                      :showSettingsBtn="false"
                                                      :relatedEventId="entryId"
                                                      :hiddenColumns="[
                                                            'eventId',
                                                            'eventName',
                                                            'eventStartDate',
                                                            'eventEndDate',
                                                            'eventSubscriptionStartDate',
                                                            'eventSubscriptionEndDate'
                                                        ]"></event-subscriptions-grid>
                        </div>
                    </tab>
                    <!-- <tab :name="'Test'" suffix="<span class='badge badge-danger'>4</span>"></tab> -->
                    <tab id="eventClaimsTab" v-if="hasEditRights && !isNew"
                         :name="$t('registers.events.eventClaims')">
                        <div v-if="eventClaimsTabActive">
                            <h4>EventClaims</h4>
                            <vue-json-pretty :path="'res'"
                                             :data="eventClaims">
                            </vue-json-pretty>
                        </div>
                    </tab>
                </tabs>
            </div>

            <div v-else>
                <div v-if="register">
                    <panel v-for="(panel, index) in register.panels" :panel="panel" :key="'register' + index"
                           @deleteSavedFile="deleteSavedFile"></panel>
                </div>
                <div class="text-center mt-5" v-if="canWriteEvents">
                    <button type="button" class="btn btn-primary btn" @click="onSubmit">
                        <i class="fas fa-save"></i>
                        {{ $t("buttons.save.btnText") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Panel from '../dynamic/Panel';
    import EventGeneralData from '../dynamic/EventGeneralData';
    import RankingCriteria from '../dynamic/RankingCriteria';
    import TempRankingManagement from '../dynamic/ranking/TempRankingManagement';
    import FormsManagement from '../dynamic/FormsManagement';
    import PageTitle from '../common/PageTitle';
    import { DynamicRegisterModel, DynamicRegisterPersonModel, EditorRegister, FormToEvent } from '@/models/models';
    import {
        ClaimsNormalized,
        ComponentType,
        Culture,
        EventClaims,
        FieldCodes,
        PersonSearchType
    } from '../../models/enums'
    import ParticipationRequestsGrid from '@/components/participants/ParticipationRequestsGrid';
    import AccommodationRequestsGrid from '@/components/accommodation/AccommodationRequestsGrid';
    import ConfirmationRejectionsGrid from '@/components/participants/ConfirmationRejectionsGrid';
    import ParticipantsManagement from '@/components/participants/ParticipantsManagement';
    import LecturersManagement from '@/components/lecturers/LecturersManagement';
    import ParticipantsImport from '@/components/participants/ParticipantsImport';
    import HallEventManagement from '@/components/scheduler/HallEventManagement';
    import OrganizationalCalendarManagement from '@/components/organizationalCalendar/Management';
    import BudgetPlanning from '@/components/budget/BugetPlanning';
    import BudgetReport from '../budget/BudgetReport';
    import Expenses from '../budget/Expenses';
    import EventSubscriptionsGrid from '@/components/subscriptions/EventSubscriptionsGrid';
    import actionLogService from '../../services/actionLog.service';
    import EventDocs from '@/components/docs/event-docs';
    import RankingCriteriaNew from '../dynamic/RankingCriteria_new';
    import UninformedPartipants from "./events/UninformedPartipants";
    import CustomTabs from '@/components/tab/CustomTabs';
    import { RegisterEventBus } from '@/buses/register-bus.js';
    import DynamicFieldChangeHandler from '@/services/dynamicFieldChangeHandler.service';
    import EventCertificateDefaultReport from '@/components/certificate/EventCertificateDefaultReport';
    import EventLecturerCertificateDefaultReport from '@/components/certificate/EventLecturerCertificateDefaultReport';
    import ParticipantsMoodleActivityCertificatesGrid
        from "@/components/participants/ParticipantsMoodleActivityCertificatesGrid";
    import VueJsonPretty from 'vue-json-pretty'
    import { mapGetters } from 'vuex';

    Vue.use(CustomTabs);

    export default {
        inject: ['$validator'],
        props: {
            registerId: {
                type: [Number, String],
                required: true
            },
            copyFromRegisterEntryId: {
                type: [Number, String],
                required: false
            },
            entryId: {
                type: [Number, String]
            },
            isEvent: {
                type: Boolean,
                default: false
            },
            registerName: {
                type: String,
                default: ''
            },
            showRelatedForms: {
                default: false,
                type: Boolean
            },
            annualCatalogItemId: {
                type: [Number, String],
                required: false
            }
        },
        components: {
            Panel,
            PageTitle,
            EventGeneralData,
            RankingCriteria,
            ParticipantsManagement,
            LecturersManagement,
            ParticipantsImport,
            TempRankingManagement,
            HallEventManagement,
            BudgetPlanning,
            BudgetReport,
            Expenses,
            OrganizationalCalendarManagement,
            FormsManagement,
            EventSubscriptionsGrid,
            EventDocs,
            ParticipationRequestsGrid,
            RankingCriteriaNew,
            EventCertificateDefaultReport,
            UninformedPartipants,
            ParticipantsMoodleActivityCertificatesGrid,
            VueJsonPretty,
            AccommodationRequestsGrid,
            ConfirmationRejectionsGrid,
            EventLecturerCertificateDefaultReport
        },
        data() {
            return {
                register: null,
                loading: false,
                files: [],
                people: [],
                loadingPeople: true,
                addresses: [],
                formToEventItems: [],
                searchQueryFormsToEvent: '',
                personSearchType: PersonSearchType,
                formsToEventgridCaptions: {
                    checked: '',
                    name: 'registers.forms.formToEvent.gridHeaders.name',
                    nameEn: 'registers.forms.formToEvent.gridHeaders.nameEn',
                    formType: 'registers.forms.formToEvent.gridHeaders.formType',
                    formTypeEn: 'registers.forms.formToEvent.gridHeaders.formTypeEn',
                    note: 'registers.forms.formToEvent.gridHeaders.note',
                    validFromUtc: 'registers.forms.formToEvent.gridHeaders.validFromUtc',
                    validToUtc: 'registers.forms.formToEvent.gridHeaders.validToUtc'
                },
                formsToEventgridColumns: ['checked', 'name', 'formType', 'note', 'validFromUtc', 'validToUtc'],
                window: {
                    width: 0,
                    height: 0
                },
                relatedFormTabActive: false,
                rankingTabActive: false,
                tempRankingTabActive: false,
                participationRequestsTabActive: false,
                accommodationRequestsTabActive: false,
                lecturersTabActive: false,
                participantsTabActive: false,
                budgetTabActive: false,
                expensesTabActive: false,
                budgetReportTabActive: false,
                importTabActive: false,
                hallEventTabActive: false,
                organizationalCalendarTaActive: false,
                subscriptionsTabActive: false,
                docsTabActive: false,
                uninformedTabActive: false,
                eventClaimsTabActive: false,
                eventDateFrom: '',
                eventDateTo: '',
                showSaveOnGeneralData: 'true',
                savedFilesToDelete: [],
                pageLoaded: false,
                initialActiveTab: null,
                showNewRankingCriteriaLogic: true,
                isSaved: false,
                currentTab: '',
                areObjectsEqual: false
            };
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();

            RegisterEventBus.$on('dynamic-field-change', this.dynamicFieldChangeHandler)
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
            this.$store.dispatch('clearCurrentRegisterData', this.register);

            RegisterEventBus.$off('dynamic-field-change', this.dynamicFieldChangeHandler)
        },
        methods: {
            dynamicFieldChangeHandler(newValue, oldValue, model) {
                DynamicFieldChangeHandler.onChangeHandler(newValue, oldValue, model, this.register);
            },
            deleteSavedFile(fileId) {
                this.savedFilesToDelete.push(fileId);
            },
            loadEmptyRegisterStructure() {
                if (!this.annualCatalogItemId) {
                    this.loadingPeople = false;
                }

                this.loading = true;
                this.$http
                    .get(`/api/dynamicRegisters/${this.registerId}/structure`)
                    .then(result => {
                        // GetStructureWithValuesById
                        this.register = new EditorRegister(result.data);
                        this.$store.initialModel = _.cloneDeep(this.register);
                        this.loading = false;
                        this.loadDataFromAnnualCatalogItem();
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    }).then(() => {
                        this.$store.dispatch('setCurrentRegisterData', this.register);
                    });
            },
            loadDataFromAnnualCatalogItem() {
                if (!this.annualCatalogItemId) {
                    return;
                }

                this.loadingPeople = true;
                this.loading = true;
                this.$http
                    .get(`/api/AnnualCatalog/GetItem/${this.annualCatalogItemId}`)
                    .then(result => {
                        this.register.panels.forEach(panel => {
                            panel.components.forEach(component => {
                                if (component.fieldCode === FieldCodes.Theme) {
                                    if (result.data.themeId) {
                                        component.fieldValue.intValue = result.data.themeId;
                                    }
                                } else if (component.fieldCode === FieldCodes.ThematicArea) {
                                    if (result.data.thematicAreaId) {
                                        component.fieldValue.intValue = result.data.thematicAreaId;
                                    }
                                } else if (component.fieldCode === FieldCodes.LegalArea) {
                                    if (result.data.legalAreaId) {
                                        component.fieldValue.intValue = result.data.legalAreaId;
                                    }
                                } else if (component.fieldCode === FieldCodes.ThemeName) {
                                    component.fieldValue.stringValue = result.data.themeName;
                                    component.fieldValue.textValue = result.data.themeName;
                                }
                            });
                        });

                        // Лектори не се прехвърлят, защото таба за участници става активен след като е записано събитието
                        /*                        if (result.data.lectors) {
                                                        // TODO: This is not working because lecctors loading was changed
                                                        result.data.lectors.forEach(lector => {
                                                            this.people.push(
                                                                new DynamicRegisterPersonModel(lector)
                                                            );
                                                        });
                                                        this.loadingPeople = false;
                                                    } */
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.loadingPeople = false;
                    });
            },
            loadRegisterStructureWithEntities() {
                this.loading = true;
                this.loadingPeople = true;

                const entryId = this.copyFromRegisterEntryId ? this.copyFromRegisterEntryId : this.entryId;

                this.$http.get(`/api/DynamicRegisters/people/${entryId}`).then(result => {
                    if (result && result.data) {
                        result.data.forEach(person => {
                            this.people.push(new DynamicRegisterPersonModel(person));
                        });
                        this.loadingPeople = false;
                    }
                });

                this.$http
                    .get(`/api/dynamicRegisters/${this.registerId}/values/${entryId}`)
                    .then(result => {
                        this.register = new EditorRegister(result.data);

                        if (this.register && this.register.deleted === true) {
                            // Събитието е изтрито. Не е позволена редакция.
                            this.$vs.notify({
                                title: this.$t('unauthorizedMessage'),
                                text: this.$t('notificationsPopup.eventDeleted.title'),
                                color: 'warning',
                                time: this.$store.getters.notificationDuration
                            });

                            this.$router.go(-1);
                        }

                        this.$store.initialModel = _.cloneDeep(this.register);
                        this.isLockedForEdit();
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    }).then(() => {
                        this.$store.dispatch('setCurrentRegisterData', this.register);
                    });
            },
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.loading = true;
                        this.files = [];
                        let fieldsValues = [];

                        const isCopy = !!this.copyFromRegisterEntryId;
                        this.register.panels.forEach(panel => {
                            panel.components.forEach(component => {
                                component.fieldValue.registerEntryId = this.entryId;
                                component.fieldValue.id = isCopy ? '' : component.fieldValue.id;
                                component.fieldValue.registerFieldId = component.id;
                                component.fieldValue.fieldType = component.fieldType;
                                component.fieldValue.numberType = component.numberType;
                                component.fieldValue.label = component.label;
                                component.fieldValue.labelEn = component.labelEn;
                                component.fieldValue.name = component.name;
                                component.fieldValue.nameEn = component.nameEn;
                                component.fieldValue.isMultiDropdown = component.isMultiDropdown;
                                if (component.isMultiDropdown) {
                                    component.fieldValue.intValue = '';
                                }
                                fieldsValues.push(component.fieldValue);
                                if (component.fieldType === ComponentType.FileUpload) {
                                    component.fieldValue.files.forEach(file => {
                                        this.files.push(file);
                                    });
                                }
                            });
                        });

                        const dynamicRegisterModel = new DynamicRegisterModel({
                            fieldValues: fieldsValues,
                            people: this.people,
                            addresses: this.addresses,
                            registerName: this.registerName,
                            registerEntityExtension: this.register.registerEntityExtension,
                            savedFilesToDeleteIds: this.savedFilesToDelete
                        });

                        this.createOrUpdate(dynamicRegisterModel);
                    } else {
                        this.$vs.notify({
                            title: this.$t('notifications.invalidUserCredentials'),
                            text: this.$t('notifications.fieldValidationErrors'),
                            color: 'warning',
                            time: this.$store.getters.notificationDuration
                        });
                    }
                });
            },
            onCopy() {
                this.$router.push({
                    name: 'events',
                    params: { copyFromRegisterEntryId: this.entryId }
                });
            },
            createOrUpdate(dynamicRegisterModel) {
                this.$http
                    .post('/api/DynamicRegisters/CreateOrUpdateDynamicRegisterEntity', dynamicRegisterModel)
                    .then(response => {
                        this.loading = false;
                        this.isSaved = true;
                        this.$store.isEventSaved = true;

                        let registerEntityId = '';
                        if (this.isNew) {
                            registerEntityId = Number(response.data.registerEntityId);
                        } else {
                            registerEntityId = Number(this.entryId);
                        }

                        try {
                            if (this.isNew) {
                                actionLogService.eventCreate(registerEntityId, dynamicRegisterModel);
                            } else {
                                actionLogService.eventUpdate(registerEntityId, dynamicRegisterModel);
                            }
                        } catch (e) {
                        }

                        if (this.files.length > 0) {
                            this.uploadFiles(registerEntityId, response.data);
                        }

                        this.$vs.notify({
                            title: response.request
                                ? this.$t('request.response.status.' + response.request.status)
                                : this.$t('request.response.status.200'),
                            text: response.data.message
                                ? response.data.message
                                : response.request.statusText
                                    ? response.request.statusText
                                    : response.message,
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        if (this.files.length <= 0) {
                            if (registerEntityId > 0) {
                                this.$router.push(`/registers/events/edit/${registerEntityId}`);
                            }
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            uploadFiles(registerEntityId, dataToMap) {
                if (this.isNew) {
                    this.files = [];
                    this.register.panels.forEach(panel => {
                        panel.components.forEach(component => {
                            if (component.fieldType === ComponentType.FileUpload) {
                                component.fieldValue.files.forEach(file => {
                                    this.files.push(file);
                                });
                            }
                        });
                    });

                    if (this.isNew) {
                        this.mapIdsToFiles(dataToMap);
                    }
                }
                let formData = new FormData();

                const descriptionsJson = this.getFilesDescriptionsJson();
                this.files.forEach(file => {
                    formData.append('files', file.content, file.fileName);
                });
                formData.append('descriptionJson', descriptionsJson);

                this.$http
                    .post('/api/DynamicRegisters/UploadFiles', formData)
                    .then(result => {
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successUploadingFiles'),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        if (this.isNew && registerEntityId > 0) {
                            this.$router.push(`/registers/events/edit/${registerEntityId}`);
                        } else {
                            this.$router.go();
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.errorUploadingFiles'),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });

                        if (registerEntityId > 0) {
                            this.$router.push(`/registers/events/edit/${registerEntityId}`);
                        }
                    });
            },
            mapIdsToFiles(ids) {
                this.files.forEach(file => {
                    const uid = file.uid;
                    const id = ids.resultList.findIndex(x => x.uid === uid);
                    if (id) {
                        file.registerEntityFieldValueId = ids.resultList[id].id;
                    }
                });
            },
            getFilesDescriptionsJson() {
                let descriptions = [];
                let fileIndex = 0;
                this.files.forEach(file => {
                    fileIndex++;
                    file.fileName = `${fileIndex}_${file.fileName}`;
                    descriptions.push({
                        fileName: file.fileName,
                        description: `${fileIndex}_${file.fileDescription}`,
                        length: file.content.size,
                        registerEntityFieldValueId: file.registerEntityFieldValueId
                    });
                });

                return JSON.stringify(descriptions);
            },
            loadFormsToEvent() {
                this.$http
                    .get('/api/dynamicForms/formsToEvent', {
                        params: {
                            eventId: this.entryId
                        }
                    })
                    .then(response => {
                        if (Array.isArray(response.data.items) && response.data.items.length > 0) {
                            response.data.items.forEach((item, index) => {
                                this.formToEventItems.push(new FormToEvent(item));
                            });
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            participantsImported() {
                var pg = this.$refs.participantsManagement;
                if (pg) {
                    pg.refreshParticipantsGrid();
                }

                var lg = this.$refs.lecturersManagement;
                if (lg) {
                    lg.refreshLecturersGrid();
                }

                var tr = this.$refs.tempRankingCriteria
                if (tr) {
                    tr.refreshLists();
                }
            },
            tempRankingApplied() {
                var pg = this.$refs.participantsManagement;
                if (pg) {
                    pg.refreshParticipantsGrid();
                }

                var lg = this.$refs.lecturersManagement;
                if (lg) {
                    lg.refreshLecturersGrid();
                }
            },
            resetActiveTabs() {
                this.relatedFormTabActive = false;
                this.rankingTabActive = false;
                this.tempRankingTabActive = false;
                this.participationRequestsTabActive = false;
                this.accommodationRequestsTabActive = false;
                this.lecturersTabActive = false;
                this.participantsTabActive = false;
                this.budgetTabActive = false;
                this.expensesTabActive = false;
                this.budgetReportTabActive = false;
                this.importTabActive = false;
                this.hallEventTabActive = false;
                this.organizationalCalendarTaActive = false;
                this.subscriptionsTabActive = false;
                this.docsTabActive = false;
                this.uninformedTabActive = false;
                this.eventClaimsTabActive = false;
            },
            tabChanged(selectedTab) {
                if (!this.pageLoaded) {
                    // The page is not loaded yet.
                    this.initialActiveTab = selectedTab;
                }

                if (!selectedTab) {
                    return;
                }

                // this.resetActiveTabs();

                switch (selectedTab.tab.id) {
                    case 'relatedFormTab':
                        if (this.relatedFormTabActive === false) {
                            this.relatedFormTabActive = true;
                            this.currentTab = 'relatedFormTab';
                        }
                        break;
                    case 'rankingTab':
                        if (this.rankingTabActive === false) {
                            this.rankingTabActive = true;
                            this.currentTab = 'rankingTab';
                        }
                        break;
                    case 'participationRequestsTab':
                        if (this.participationRequestsTabActive === false) {
                            this.participationRequestsTabActive = true;
                            this.currentTab = 'participationRequestsTab';
                        }
                        break;
                    case 'accommodationRequestsTab':
                        if (this.accommodationRequestsTabActive === false) {
                            this.accommodationRequestsTabActive = true;
                            this.currentTab = 'accommodationRequestsTab';
                        }
                        break;
                    case 'tempRankingTab':
                        if (this.tempRankingTabActive === false) {
                            this.tempRankingTabActive = true;
                            this.currentTab = 'tempRankingTab';
                        }
                        break;
                    case 'uninformedParticipantsTab':
                        if (this.uninformedTabActive === false) {
                            this.uninformedTabActive = true;
                            this.currentTab = 'uninformedParticipants';
                        }
                        break;
                    case 'participantsTab':
                        if (this.participantsTabActive === false) {
                            this.participantsTabActive = true;
                            this.currentTab = 'participantsTab';
                        }
                        break;
                    case 'lecturersTab':
                        if (this.lecturersTabActive === false) {
                            this.lecturersTabActive = true;
                            this.currentTab = 'lecturersTab';
                        }
                        break;
                    case 'budgetTab':
                        if (this.budgetTabActive === false) {
                            this.budgetTabActive = true;
                            this.expensesTabActive = false;
                            this.currentTab = 'budgetTab';
                        }
                        break;
                    case 'expensesTab':
                        if (this.expensesTabActive === false) {
                            this.expensesTabActive = true;
                            this.budgetTabActive = false;
                            this.budgetReportTabActive = false;
                            this.currentTab = 'expensesTab';
                        }
                        break;
                    case 'budgetReportTab':
                        if (this.budgetReportTabActive === false) {
                            this.budgetReportTabActive = true;
                            this.expensesTabActive = false;
                            this.currentTab = 'budgetReportTab';
                        }
                        break;
                    case 'importTab':
                        if (this.importTabActive === false) {
                            this.importTabActive = true;
                            this.currentTab = 'importTab';
                        }
                        break;
                    case 'hallEventTab':
                        if (this.hallEventTabActive === false) {
                            this.hallEventTabActive = true;
                            this.currentTab = 'hallEventTab';
                        }
                        break;
                    case 'organizationalCalendarTab':
                        if (this.organizationalCalendarTaActive === false) {
                            this.organizationalCalendarTaActive = true;
                            this.currentTab = 'organizationalCalendarTab';
                        }
                        break;
                    case 'subscriptionsTab':
                        if (this.subscriptionsTabActive === false) {
                            this.subscriptionsTabActive = true;
                            this.currentTab = 'subscriptionsTab';
                        }
                        break;
                    case 'documentsTab':
                        if (this.docsTabActive === false) {
                            this.docsTabActive = true;
                            this.currentTab = 'documentsTab';
                        }
                        break;
                    case 'eventClaimsTab':
                        if (this.eventClaimsTabActive === false) {
                            this.eventClaimsTabActive = true;
                            this.currentTab = 'eventClaimsTab';
                        }
                        break;
                    default:
                        this.currentTab = 'generalTab';
                        break;
                }
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            haveClaimReadRights(claim) {
                if (this.isNew) {
                    return true;
                }

                if (!claim) {
                    return false;
                }

                if (claim.read || claim.create || claim.update || claim.delete) {
                    return true;
                }

                return false;
            },
            haveClaimWritePermisions(claim) {
                if (this.isNew) {
                    return true;
                }

                if (!claim) {
                    return false;
                }

                if (claim.create || claim.update) {
                    return true;
                }

                return false;
            },
            unLockForEditButtonClicked() {
                // TODO: Dialog който да казва, че ще се презареди страницата и няма да се запазят промените...
                this.unLockForEdit();
            },
            unLockForEdit() {
                this.loading = true;
                this.$http.post(`/api/DynamicRegisters/UnlockForEdit/${this.entryId}`).then(result => {
                    this.showSaveOnGeneralData = true;
                    this.$router.go();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false });
            },
            isLockedForEdit() {
                if (this.register.registerEntityExtension.isLockedForEdit) {
                    this.showSaveOnGeneralData = false;
                }
            },
        },
        mounted() {
            this.copyFromRegisterEntryId = this.$route.params.copyFromRegisterEntryId;

            if (!this.isNew && !this.$store.getters.eventEditRights) {
                return this.$router.push(`/unauthorized`);
            }

            this.pageLoaded = true;

            if (this.isNew && !this.copyFromRegisterEntryId) {
                this.loadEmptyRegisterStructure();
            } else {
                actionLogService.eventOpenForEdit(this.entryId);

                this.loadRegisterStructureWithEntities();
            }

            if (this.isEvent) {
                this.loadFormsToEvent();
            }
        },
        watch: {
            'register': {
                immediate: true,
                deep: true,
                handler(newVal, oldVal) {
                    this.areObjectsEqual = _.isEqual(newVal, this.$store.initialModel);
                }
            },
            currentTab: {
                immediate: true,
                handler(newVal, oldVal) {
                    let shouldShowMessage = !this.areObjectsEqual && !this.$store.isEventSaved && newVal === 'generalTab';
                    this.$emit('shouldShowMessage', shouldShowMessage);
                }
            }
        },
        computed: {
            ...mapGetters(['eventClaims']),
            isNew() {
                return this.entryId === undefined || isNaN(this.entryId) || this.entryId <= 0;
            },
            isBgCulture() {
                return this.$store.getters.currentCulture === Culture.BG;
            },
            hasItems() {
                return Array.isArray(this.formToEventItems) && this.formToEventItems.length;
            },
            hasReadRights() {
                const canReadEvent = this.$store.getters.eventReadRights || this.$store.getters.claims.event.read;

                return canReadEvent;
            },
            hasEditRights() {
                const canEditEvent =
                    this.$store.getters.eventEditRights ||
                    this.$store.getters.claims.event.update ||
                    this.$store.getters.claims.event.create ||
                    this.$store.getters.claims.event.delete;

                return canEditEvent;
            },
            windowWidth() {
                return `${this.window.width}px`;
            },
            eventClaims() {
                return this.$store.getters.eventClaims;
            },
            canReadFormsManagеment() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventFormManagement];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadRankingCriteria() {
                const claim = this.$store.getters.eventClaims[EventClaims.RankingCriteria];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadTempRanking() {
                const claim = this.$store.getters.eventClaims[EventClaims.TempRanking];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadLectors() {
                return this.canReadParticipants;
            },
            canReadParticipants() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventParticipantManagement];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadBudget() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventBudget];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadExpenses() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventCosts];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadBudgetReport() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventReport];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadOrganizationalCalendar() {
                const claim = this.$store.getters.eventClaims[EventClaims.OrganizationalCalendar];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadSubscriptions() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventSubscriptions];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canReadUninformedPerticipants() {
                const claim = this.$store.getters.eventClaims[EventClaims.UninformedParticipants]
                const canWrite = this.haveClaimReadRights(claim);
                return canWrite;
            },
            canWriteBudget() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventBudget];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteExpenses() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventCosts];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteBudgetRreport() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventReport];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteParticipants() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventParticipantManagement];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteEvents() {
                const claim = this.$store.getters.eventClaims[EventClaims.Event];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteForms() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventFormManagement];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteTempRanking() {
                const claim = this.$store.getters.eventClaims[EventClaims.TempRanking];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canWriteUninformedPerticipants() {
                const claim = this.$store.getters.eventClaims[EventClaims.UninformedParticipants]
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canUnlockForEdit() {
                const claim = this.$store.getters.eventClaims[ClaimsNormalized.FinancialControl];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            eventName() {
                if (!this.register) {
                    return '';
                }
                let eventName = '';
                this.register.panels.filter(p => {
                    p.components.filter(c => {
                        if (c.hasOwnProperty('fieldCode') && c['fieldCode'] === 'Event_name') {
                            if (c.hasOwnProperty('fieldValue') && c['fieldValue'].hasOwnProperty('textValue')) {
                                eventName = c['fieldValue']['textValue'];
                            }
                        }
                    });
                });
                return eventName;
            },
            formTitle() {
                let title = this.isBgCulture
                    ? (this.register ? this.register.name : '')
                    : (this.register ? this.register.nameEn : '');

                title += this.entryId
                    ? ' / ' + this.$t('buttons.edit.btnText')
                    : ' / ' + this.$t('buttons.create.btnText');

                return title;
            },
            eventFormIds() {
                let evenFormIds = '';

                if (!this.register || !this.register.panels) {
                    return evenFormIds;
                }

                this.register.panels.forEach(panel => {
                    panel.components.forEach(component => {
                        if (component.fieldCode === FieldCodes.EventForm && component.fieldType === 'Dropdown') {
                            if (component.isMultiDropdown) {
                                evenFormIds = component.fieldValue.textValue;
                            } else {
                                evenFormIds = component.fieldValue.intValue;
                            }
                        }
                    });
                });

                return evenFormIds;
            }
        }
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        .nav-tabs .nav-link.active {
            color: #009688;
            border-bottom: 1px solid #009688;
        }

        .nav-tabs .nav-link {
            color: #212529;
            border-bottom: 1px solid lightgrey;
            transition: border-color 1s;

            &:hover {
                text-decoration: none;
                color: #009688;
            }
        }
        .tabs-component-panels {
            padding-left: 0;
            padding-right: 0;
            padding-bottom: 0;
        }
    }
</style>
